import React, {FC, PropsWithChildren} from 'react';

/**
 *  NOTE: itemId is required for track items
 * @param param itemId - @see https://www.npmjs.com/package/react-horizontal-scrolling-menu
 * @returns wrapped component
 */
export const ScrollingMenuCard: FC<PropsWithChildren<{itemId: string}>> = React.memo(({children, itemId}) => {
  return (
    <div style={{height: '100%'}} key={itemId}>
      {children}
    </div>
  );
});
